import { render, staticRenderFns } from "./contact-info-detail-popup.vue?vue&type=template&id=36342a84&scoped=true"
import script from "./contact-info-detail-popup.vue?vue&type=script&lang=js"
export * from "./contact-info-detail-popup.vue?vue&type=script&lang=js"
import style0 from "./contact-info-detail-popup.vue?vue&type=style&index=0&id=36342a84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36342a84",
  null
  
)

export default component.exports